export default {
  title: '运营看板',
  totalOrders: '订单总数',
  totalWeight: '总重量',
  totalRevenue: '总收入',
  totalProfit: '总利润',
  todayOrders: '今日订单',
  pendingOrders: '待处理订单',
  recentOrders: '最近订单',
  orderTrend: '订单趋势',
  profitTrend: '利润趋势',
  topCustomers: 'top客户',
  topRoutes: '热门航线',
  todayConsignments: '今日委托',
  totalWeightKG: '总重量(KG)',
  grossProfitRate: '毛利率',
  businessCalendar: '业务日历',
  monthFormat: '{y}年{m}月',
  consignmentShort: '委托:',
  mawbShort: '主单:',
  weightShort: '重量:',
  airlineDistribution: '航司货量分布',
  grossProfit: '毛利',
  airlineShort: '航司:',
  noDayData: '该日暂无业务数据',
  businessDetail: '业务详情',
  orderCount: '订单数',
  profit: '利润',
  airlineCargo: '航司货量',
  unknown: '未知',
  weekDaysShort: ['日', '一', '二', '三', '四', '五', '六'],
  weekDaysLong: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
  fetchStatsFailed: '获取统计数据失败',
  fetchTrendFailed: '获取趋势数据失败',
  fetchRouteFailed: '获取航线分布数据失败',
  fetchCalendarFailed: '获取日历数据失败',
  initTrendChartFailed: '初始化趋势图表失败',
  initRouteChartFailed: '初始化航线分布图表失败',
  // businessOrders 页面统计
  totalBizOrders: '总业务委托数',
  totalSalesGrossProfit: '总销售毛利',
  totalProductGrossProfit: '总产品毛利',
  // productOrderRecord 页面统计
  filterResult: '筛选结果',
  totalSalesRevenue: '总营收',
  totalCost: '总成本',
  totalGrossProfit: '总毛利',
  avgMargin: '平均利润率',
  currencySymbol: '¥',
  weightUnit: 'KG',
  weightUnitShort: 'KGS',
}
